var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.707,27.163L36.837,.293c-.391-.391-1.023-.391-1.414,0L17.293,18.423c-.391,.391-.391,1.023,0,1.414s1.023,.391,1.414,0L36.13,2.414l25.456,25.456-19.293,19.293c-.391,.391-.391,1.023,0,1.414,.195,.195,.451,.293,.707,.293s.512-.098,.707-.293l20-20c.391-.391,.391-1.023,0-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.707,42.506l13.929-13.929c.391-.391,.391-1.023,0-1.414L36.837,7.364c-.391-.391-1.023-.391-1.414,0l-12.13,12.13c-.391,.391-.391,1.023,0,1.414s1.023,.391,1.414,0l11.423-11.423,18.385,18.385-13.222,13.222c-.391,.391-.391,1.023,0,1.414,.195,.195,.451,.293,.707,.293s.512-.098,.707-.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,22H1c-.553,0-1,.447-1,1V63c0,.553,.447,1,1,1H39c.553,0,1-.447,1-1V23c0-.553-.447-1-1-1Zm-1,40H2V24H38V62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,53h28c.553,0,1-.447,1-1V28c0-.553-.447-1-1-1H6c-.553,0-1,.447-1,1v24c0,.553,.447,1,1,1Zm1-24h26v22H7V29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.65,38.241c-.373-.322-.928-.322-1.301,0l-7,6c-.42,.359-.469,.99-.108,1.409,.359,.422,.991,.47,1.409,.108l6.35-5.441,6.35,5.441c.188,.162,.42,.241,.65,.241,.281,0,.562-.118,.759-.35,.36-.419,.312-1.05-.108-1.409l-7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.65,36.241c-.373-.322-.928-.322-1.301,0l-3,2.571c-.42,.359-.469,.99-.108,1.409,.359,.421,.991,.469,1.409,.108l2.35-2.013,6.35,5.441c.188,.162,.42,.241,.65,.241,.281,0,.562-.118,.759-.35,.36-.419,.312-1.05-.108-1.409l-7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,37c1.654,0,3-1.346,3-3s-1.346-3-3-3-3,1.346-3,3,1.346,3,3,3Zm0-4c.552,0,1,.448,1,1s-.448,1-1,1-1-.448-1-1,.448-1,1-1Z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "a`"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.e285d1c725b53aeab38eabfdacad2195.svg";
export { ForwardRef as ReactComponent };